import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import SeparationActive from "./SeparationActive";

const STATE_SORT = {
  ASC: 0,
  DESC: 1,
};

const TableReport = ({ dataChartSeparationRedux, separationActive }) => {
  const [dataChartSeparation, setDataChartSeparation] = useState({});
  const [stateSortCost, setStateSortCost] = useState(STATE_SORT.ASC);
  const [stateSortView, setStateSortView] = useState(STATE_SORT.ASC);
  const [stateSortTimeView, setStateSortTimeView] = useState(STATE_SORT.ASC);
  let title = "";

  useEffect(() => {
    setDataChartSeparation(dataChartSeparationRedux);
  }, [dataChartSeparationRedux]);

  const convertToArray = (dataChartSeparation) => {
    let dataChartSeparationArray = [];
    for (let key in dataChartSeparation) {
      const item = dataChartSeparation[key];
      dataChartSeparationArray.push({
        name: key,
        click: item.click,
        cost: item.cost,
        view: item.view,
        time_view: item.time_view,
      });
    }
    return dataChartSeparationArray;
  };

  const convertToObject = (dataChartSeparationArray) => {
    let dataChartSeparationObject = {};
    for (let key in dataChartSeparationArray) {
      const item = dataChartSeparationArray[key];
      dataChartSeparationObject[item.name] = {
        click: item.click,
        cost: item.cost,
        view: item.view,
        time_view: item.time_view,
      };
    }
    return dataChartSeparationObject;
  };

  const sortTable = (column, state) => {
    let dataChartSeparationArray = convertToArray(dataChartSeparation);
    dataChartSeparationArray = dataChartSeparationArray.sort((a, b) => {
      if (state == STATE_SORT.ASC) {
        return parseFloat(a[column]) - parseFloat(b[column]);
      } else if (state == STATE_SORT.DESC) {
        return parseFloat(b[column]) - parseFloat(a[column]);
      }
    });

    let dataChartSeparationObject = convertToObject(dataChartSeparationArray);

    setDataChartSeparation(dataChartSeparationObject);
  };

  const generateTable = () => {
    switch (separationActive) {
      case SeparationActive.CAMPAIGN:
        title = "عنوان کمپین";
        break;
      case SeparationActive.PUBLISHER:
        title = "سایت نمایش دهنده";
        break;
      case SeparationActive.ADVERTISE:
        title = "شماره تبلیغ";
        break;
      case SeparationActive.TIME:
        title = "زمان";
        break;
      case SeparationActive.POSITION:
        title = "جایگاه";
        break;
    }
    if (Object.entries(dataChartSeparation).length == 0) {
      return <></>;
    }

    return (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-3">
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space mb-0">
            <thead>
              <tr>
                <td>{title}</td>
                <td>
                  <span>تعداد نمایش</span>
                  <span
                    className="pr-2 hover"
                    onClick={(e) => {
                      sortTable("view", stateSortView);
                      setStateSortView((prevState) => !prevState);
                    }}
                  >
                    <i
                      className={`fa fa-angle-${
                        stateSortView == STATE_SORT.ASC ? "up" : "down"
                      }`}
                    ></i>
                  </span>
                </td>
                {/* <td>کلیک</td> */}
                <td>
                  <span> زمان نمایش (دقیقه)</span>
                  <span
                    className="pr-2 hover"
                    onClick={(e) => {
                      sortTable("time_view", stateSortTimeView);
                      setStateSortTimeView((prevState) => !prevState);
                    }}
                  >
                    <i
                      className={`fa fa-angle-${
                        stateSortTimeView == STATE_SORT.ASC ? "up" : "down"
                      }`}
                    ></i>
                  </span>
                </td>
                <td>
                  <span>هزینه</span>
                  <span
                    className="pr-2 hover"
                    onClick={(e) => {
                      sortTable("cost", stateSortCost);
                      setStateSortCost((prevState) => !prevState);
                    }}
                  >
                    <i
                      className={`fa fa-angle-${
                        stateSortCost == STATE_SORT.ASC ? "up" : "down"
                      }`}
                    ></i>
                  </span>
                </td>
              </tr>
            </thead>

            <tbody>{generateBody()}</tbody>
          </table>
        </div>
      </div>
    );
  };

  const generateBody = () => {
    return Object.entries(dataChartSeparation).map((item) => {
      let key = item[0];
      let value = item[1];
      switch (separationActive) {
        case SeparationActive.PUBLISHER:
          key = (
            <a href={key} target="_blank">
              {key}
            </a>
          );
          break;
        case SeparationActive.ADVERTISE:
          key = helpersNumbers.toPersianNum(key);
          break;
        case SeparationActive.TIME:
          if (separationActive == SeparationActive.TIME) {
            if (key.includes("hilite-")) {
              break;
            }
            if (key.includes(":")) {
              key = helpersNumbers.toPersianNum(
                key.replace("-", " تا ").split(" ").reverse().join(" ")
              );
            } else if (key.includes("-")) {
              key = helpersNumbers
                .toPersianNum(
                  helpersTime.convertGregorianToJalali(key, "MMMM DD ddd")
                )
                .split(" ")
                .reverse()
                .join(" ");
            }
          }
          break;
      }
      return (
        <tr>
          <td>{key}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.addCommaToSeparateGroupThreeNumber(value.view)
            )}
          </td>
          {/* <td>{helpersNumbers.toPersianNum(dataChartSeparationItem.click)}</td> */}
          <td>
            {helpersNumbers.toPersianNum(Math.floor(value.time_view / 60))}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.addCommaToSeparateGroupThreeNumber(value.cost)
            )}
          </td>
        </tr>
      );
    });
  };

  return <>{generateTable()}</>;
};

const mapStateToProps = (state) => {
  return {
    dataChartSeparationRedux: state.reportCampaign.data_chart_separation,
    separationActive: state.reportCampaign.which_separation_active,
  };
};

export default connect(mapStateToProps, null)(TableReport);
